export default "__VITE_ASSET__DgZPU7ym__"